import React from "react";

const Quote = ({ quote }) => {
	return (
		<p>
			<span>&#10077;</span>
			{quote}
		</p>
	);
};
export default Quote;
